import React, { Component } from "react";
import axios from "axios";
//import PropTypes from "prop-types";
import settings from "client.settings.json";
import "./loginDigiD.css";
import { connect } from "react-redux";
import { translate } from "reducers/i18n";
import digidLogo from "../../graphics/digid-logo.svg";


class LoginDigiD extends Component {
  state = {
    loading: false,
    messageIdIsValid: false,
    codeIsRequested: false,
    error: null,
    retry: null,
  };

  componentDidMount() {
    this.validateMessageId();

    let query = {}
    let queryString = this.props.location.search?.substring(1)
    let matchQueryParam = /(?<key>[^=]+?)(?:=(?<value>[^&]*?))?(&|$)/y
    let matchQueryParamResult
    while(matchQueryParamResult = matchQueryParam.exec(queryString)) {
      let {key, value} = matchQueryParamResult.groups
      query[key] = decodeURI(value)
    }

    if(query.status === 'cancelled') {
        this.setState({ error: {message: translate('digid_cancelled')} });
    } else if (query.status === 'unauthorised') {
        this.setState({ error: {message: translate('digid_unauthorised')} });
    } else if (query.status === 'error') {
        this.setState({ error: {message: translate('digid_error')} });
    }
  }

  componentDidUpdate(prevProps, prevState) {
  }



  render() {
    return (
      <div className="loginDigiDForm panel">
        <div className="panelHeader header_fontFamily"><h1>{translate("_login")}</h1></div>

        {(() => {

          if (this.state.loading)
            return <div className="panelContent"><p>{translate("_isLoading")}...</p></div>

          else if (this.state.error)
            return <div>
              <div className="panelContent">
                <p>
                  {translate("_something_went_wrong")}: &nbsp;
                    { this.state.error.response?.data?.errorcode
                      ? translate(this.state.error.response?.data?.errorcode)
                      : this.state.error.message
                    }
                </p>
              </div>
              <div className="panelFooter buttons_fontFamily">
                {this.state.retry
                  ? <button title={translate("_tryAgain")} className="button  " onClick={() => { this.setState({ error: null }); this.state.retry(); }}>{translate("_tryAgain")}</button>
                  : <button title={translate("_tryAgainLater")} className=" button" disabled={true}>{translate("_tryAgainLater")}</button>
                }
              </div>
            </div>

          else
            return <div>
              <div className="panelContent panelContentWithImage">
                <img src={digidLogo} alt="DigiD logo" />
                <p dangerouslySetInnerHTML={{__html: translate("digid_introduction", "Bastion 365 (test)")}}/>
              </div>
              <div className="panelFooter buttons_fontFamily">
                <button title={translate("digid_login")} className="button primary " onClick={() => this.login()}>{translate("digid_login")}</button>
                {/* <button title={translate("digid_nodigid")} className="button" onClick={() => {}}>{translate("digid_nodigid")}</button> */}
              </div>
            </div>

        })()}

      </div>
    );
  }


  validateMessageId = () => {
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/digidlogin/validatemessageid",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId
      }
    }).then(
      response => {
        if ( response && response.data)
          this.setState({ loading: false, messageIdIsValid: true });
        else
          this.setState({ loading: false, messageIdIsValid: false });
      },
      error => {  this.setState({ loading: false, error: error, retry: (() => { this.validateMessageId(); }) }) }
    );

  }

  login = () => {
    let {tenantId, messageId} = this.props.match.params
    window.location.href = `${window.location.origin}/saml/login?RelayState=/edelivery/${tenantId}/messages/${messageId}`;
  }

}




//export default LoginDigiD


const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(LoginDigiD);
